import React from "react";
import Button from "@gc-npm/components.button";
import StreamingCarouse from "./streaming-carousel";
import Header from "./header";
import style from "./style";

const StreamingPlatformsSection = (props) => {
  const carouselContent = Object.keys(props["Carrusel"])
    .filter((key) => key.startsWith("Slide-"))
    .map((key) => props["Carrusel"][key]);

  const taggingInfo = props["taggingInfo"];
  const mainButton = props["Button-0"];

  return (
    <>
      <section className="streaming-platforms-section" data-cy="Section StreamingPlatforms">
        <div className="content-container container">
          <Header
            title={props["Information-Card"]["Text-1"]}
            subTitle={props["Information-Card"]["Text-2"]}
          />
          <StreamingCarouse
            slides={carouselContent}
            taggingInfo={taggingInfo}
          />
          <div className="container-button-configura">
            {mainButton && (
              <Button
                {...mainButton}
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: mainButton?.label,
                }}
                type="link"
                cyData="StreamingPlatforms Button Configura"
              />
            )}
          </div>
        </div>
      </section>
      <style jsx>{style}</style>
    </>
  );
};

export default StreamingPlatformsSection;
